import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "lb-loading" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "请稍候", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.loading,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loading) = $event)),
    centered: "",
    closable: false,
    "mask-closable": false,
    footer: null,
    width: 200
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_spin, { size: "large" }),
        _hoisted_2,
        _hoisted_3
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}